module.exports = __webpack_public_path__ + "media/images/vp/icon.menu.events.red-11a65b8ef32a63d3c094e250f3c828f3.svg";